import { Box3, Vector3, type Mesh, type Object3D } from 'three'
import { PREFIXO_SELECIONAVEL } from '../camera/comandosCamera'

/**
 * Coleta os meshes visíveis pertencentes à peça selecionada respeitando
 * a hierarquia de grupos. Se uma subpeça (ex: dobradiça) for selecionada,
 * apenas os meshes sob o grupo daquela subpeça serão retornados.
 */
function acharAlvo(scene: Object3D, nome: string): Object3D | null {
  let encontrado: Object3D | null = null
  scene.traverse((objeto) => {
    if (objeto.name === nome && !encontrado) {
      encontrado = objeto
    }
  })
  return encontrado
}

export function coletarMeshesDaPeca(scene: Object3D, id: string): Mesh[] {
  if (!id) return []
  const nomeProcurado = `${PREFIXO_SELECIONAVEL}${id}`
  const alvo = acharAlvo(scene, nomeProcurado)

  if (!alvo) return []

  const meshes: Mesh[] = []
  alvo.traverse((filho: Object3D) => {
    if ((filho as Mesh).isMesh) {
      const mesh = filho as Mesh
      let visivel = mesh.visible
      let cursor: Object3D | null = mesh.parent
      while (cursor && cursor !== alvo && visivel) {
        if (!cursor.visible) visivel = false
        cursor = cursor.parent
      }

      const nomeMesh = mesh.name || ''
      const eAuxiliar =
        nomeMesh.startsWith('auxiliar:') ||
        nomeMesh.startsWith('halo:') ||
        nomeMesh.includes('shadow')

      if (visivel && !eAuxiliar) {
        meshes.push(mesh)
      }
    }
  })

  return meshes
}

/**
 * Calcula a posição ideal para o rótulo 3D ancorado ligeiramente
 * acima do topo da caixa delimitadora dos meshes selecionados.
 */
export function calcularPosicaoRotulo(meshes: Mesh[]): [number, number, number] | null {
  if (!meshes || meshes.length === 0) return null
  const box = new Box3()
  for (const mesh of meshes) {
    box.expandByObject(mesh)
  }
  if (box.isEmpty()) return null
  const center = new Vector3()
  box.getCenter(center)
  return [center.x, box.max.y + 0.12, center.z]
}
